import { charTypeRequester } from '../../../account/administration/FormTemplates/utils/utils';
import { Key } from 'ts-key-enum';

function FormattedCharacterInput(props) {
  const { index, characterObject, onChange, onClick, disabled = false, inputRef, onKeyDown } = props;

  const { regex, value } = characterObject;

  if (regex === '-') return <div className="formatted-input__input_container formatted-input__hyphen">{regex}</div>;

  const handleOnKeyDown = (event, index) => {
    if (event.key === Key.Backspace || event.key === Key.Delete) {
      onKeyDown(event, index);
    }
  };

  return (
    <div className="formatted-input__input_container">
      <input
        placeholder={charTypeRequester(regex, 'symbol')}
        onClick={(event) => onClick(event)}
        onChange={(event) => onChange(event, index)}
        onKeyDown={handleOnKeyDown}
        disabled={disabled}
        value={value}
        maxLength="1"
        ref={inputRef}
      />
    </div>
  );
}

export default FormattedCharacterInput;
